import { Injectable } from '@angular/core';
import { Headers } from '@angular/http';
import { ServiceConfig } from './service-config';
import { Observable, Subscription } from 'rxjs';
import { saveAs as importedSaveAs } from 'file-saver';
import { Workbook } from 'exceljs';
import { HttpClient } from '@angular/common/http';
import { ReportLoadingService } from './report-loading.service';
@Injectable()
export class ReportService {
  subscription: Subscription;
  private host = ServiceConfig.host;
  private baseUrl = this.host + '/api/ipcc/';
  private BASE_URL_LOGGER = this.host + '/api/log-management/';
  private BASE_URL_FOLLOW_REPORT = this.host + '/api/follow-report/';
  private data: any;
  headers: Headers;

  isLoading: Boolean;
  constructor(private http: HttpClient, private reportLoadingService: ReportLoadingService) {
    this.data = JSON.parse(localStorage.getItem('currentSmmData'));
    this.headers = new Headers({
      'Content-Type': 'application/json'
    });
  }
  // báo cáo cảm xúc theo chủ đề
  getSentimentReport(optionsFilter): Observable<any> {
    let url = this.baseUrl + '/report/sentimentReport?token=' + this.data.token;
    return this.http.post<any>(url, optionsFilter);
  }

  // báo cáo kri
  getKriReport(optionsFilter): Observable<any> {
    let url = this.baseUrl + '/report/kriReport?token=' + this.data.token;
    return this.http.post<any>(url, optionsFilter);
  }

  // sửa báo cáo kri
  fixHearing(optionsFilter): Observable<any> {
    let url = this.baseUrl + '/report/fixHearing?token=' + this.data.token;
    return this.http.post<any>(url, optionsFilter);
  }

  // xuất báo cáo kri
  getExportKriReport(optionsFilter): Observable<any> {
    let url = this.baseUrl + '/report/exportKriReport?token=' + this.data.token;
    return this.http.post<any>(url, optionsFilter);
  }

    // báo cáo giám sát kri
    getKriMonitorReport(optionsFilter): Observable<any> {
      let url = this.baseUrl + '/report/kriMonitorReport?token=' + this.data.token;
      return this.http.post<any>(url, optionsFilter);
    }

  // báo cáo link tồn
  getBacklogLinkReport(optionsFilter): Observable<any> {
    let url = this.baseUrl + '/report/backlog-link-report?token=' + this.data.token;
    return this.http.post<any>(url, optionsFilter);
  }

  // báo cáo cảm xúc theo chủ đề thảo luận
  getDiscussSentimentReport(optionsFilter): Observable<any> {
    let url = this.baseUrl + '/report/discussSentimentReport?token=' + this.data.token;
    return this.http.post<any>(url, optionsFilter);
  }
  getProvinceSentimentReport(optionsFilter): Observable<any> {
    let url = this.baseUrl + '/report/provinceSentimentReport?token=' + this.data.token;
    return this.http.post<any>(url, optionsFilter);
  }

  // báo cáo tổng hợp phụ lục tương tác
  getReportSummarySeeding(optionsFilter): Observable<any> {
    let url = this.baseUrl + '/report/getReportSummarySeeding?token=' + this.data.token;
    return this.http.post<any>(url, optionsFilter);
  }

  // bao cao tuong tac
  getSeedingActions(optionsFilter): Observable<any> {
    let url = this.BASE_URL_LOGGER + '?token=' + this.data.token;
    return this.http.post<any>(url, optionsFilter);
  }
  // bao cao theo doi xu ly
  public updateFollowReportItem(body) {
    let url = this.BASE_URL_FOLLOW_REPORT + 'update?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public getHistory(body) {
    let url = this.BASE_URL_FOLLOW_REPORT + 'getHistory?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public updateProcess(body) {
    let url = this.BASE_URL_FOLLOW_REPORT + 'updateStatus?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public createFollowReportItem(body) {
    let url = this.BASE_URL_FOLLOW_REPORT + 'createNewFollowItemReport?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  // bao cao xu ly theo doigetProcessFollowReport
  public getProcessFollowReport(body) {
    let url = this.BASE_URL_FOLLOW_REPORT + '?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  public removeFollowReportItem(body) {
    let url = this.BASE_URL_FOLLOW_REPORT + 'removeFollow?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public deleteFollowReportItem(body) {
    let url = this.BASE_URL_FOLLOW_REPORT + 'deleteFollow?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  //removeFollow

  //bao cao tong hop - thanhdv
  public synthesisReport(body) {
    let url = this.baseUrl + '/report/synthesisReport?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  //bao cao luu luong theo ngay -thanhdv
  public dailyTrafficReport(body) {
    let url = this.baseUrl + '/report/dailyTrafficReport?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  // bao cao ty le dap ung -vdthuan
  public responserRateReport(body) {
    let url = this.baseUrl + '/report/response-rate?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  // bao cao mang xã hoi -vdthuan
  public socialReport(body) {
    let url = this.baseUrl + '/report/socialReport?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  //bao cao chi tiet noi dung-thanhdv
  public detailContentReport(body) {
    let url = this.baseUrl + '/report/detailContentReport?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  //bao cao giam sat
  public supervisionReport(body) {
    let url = this.baseUrl + '/report/supervisionReport?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  // bao cao giam sát hearing
  public hearingMonitorReport(body) {
    let url = this.baseUrl + '/report/hearing-monitor-report?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public ktvMonitorReport(body) {
    let url = this.baseUrl + '/report/ktv-monitor-report?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  //bao cao giam sat- luu luong theo ngay
  public supervisionDailyTrafficReport(body) {
    let url = this.baseUrl + '/report/supervisionDailyTrafficReport?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
  //xuat file excel -thanhdv
  public exportReportToExcel(dataExport, fileName = 'Report'): boolean {
    let workbook = new Workbook();

    if (dataExport) {
      // console.log(req.body.data);
      for (var m = 0; m < dataExport.length; m++) {
        let dataSheet = dataExport[m];
        let headerSheet = dataSheet.header;
        let nameSheet = "Báo cáo";
        if (dataSheet.name) {
          nameSheet = dataSheet.name;
        }
        var worksheet2 = workbook.addWorksheet(nameSheet, {

          pageSetup: { fitToPage: true, fitToHeight: 5, fitToWidth: 1 }

        });
        // workbook.columns.forEach(column => {
        //   column.width = column.header.length < 12 ? 12 : column.header.length
        // })
        // worksheet2.properties.defaultRowHeight = 20;
        // worksheet2.properties.dyDescent = 30;
        let mergeCellsHeader = Array();
        for (var i = 0; i < headerSheet.length; i++) {
          let arrHeaderName = Array();
          var start = headerSheet[i][0].start;
          for (var k = 1; k < start; k++) {
            arrHeaderName.push("");
          }
          for (var j = 1; j < headerSheet[i].length; j++) {
            arrHeaderName.push(headerSheet[i][j].name);
            if (headerSheet[i][j].colspan) { //colspan
              let colspan = parseInt(headerSheet[i][j].colspan);
              let columnStart = (arrHeaderName.length) ? arrHeaderName.length : 1;
              let arrColspan = [i + 1, columnStart, i + 1, columnStart + colspan - 1];
              mergeCellsHeader.push(arrColspan);
              for (var h = 1; h < colspan; h++) {
                arrHeaderName.push("");
              }
            }
            if (headerSheet[i][j].rowspan) { //rowspan
              let rowspan = parseInt(headerSheet[i][j].rowspan);
              let columnStart = (arrHeaderName.length) ? arrHeaderName.length : 1;
              let arrrowspan = [i + 1, columnStart, i + rowspan, columnStart];
              mergeCellsHeader.push(arrrowspan);
            }
          }

          worksheet2.addRow(arrHeaderName);
        }
        for (var i = 0; i < mergeCellsHeader.length; i++) {
          worksheet2.mergeCells(mergeCellsHeader[i]);
        }
        worksheet2.eachRow(function (row, rowNumber) {
          row.eachCell(function (cell, colNumber) {
            row.getCell(colNumber).font = { bold: true, color: { argb: 'FFFFFF' } };
            row.getCell(colNumber).alignment = { vertical: 'middle', horizontal: 'center' };
            row.getCell(colNumber).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '009ed6' }, bgColor: { argb: '009ed6' } };
          });
        });
        // do du lieu
        var data = Array();
        data = dataSheet.data;
        for (var i = 0; i < data.length; i++) {
          var arrValues = Object.keys(data[i]).map(key => data[i][key]);
          if (dataSheet.notStt == undefined) {
            arrValues.splice(0, 0, i + 1);
          }
          // console.log(arrValues);
          worksheet2.addRow(arrValues);
        }
        worksheet2.eachRow(function (row, rowNumber) {
          row.eachCell(function (cell, colNumber) {
            //them wraptext cho tung o
            row.getCell(colNumber).alignment = {wrapText : true}
          });
        });
        //footer
        if (dataSheet.footer) {
          var arrValues = Object.keys(dataSheet.footer.data).map(key => dataSheet.footer.data[key]);
          for (var i = 1; i < parseInt(dataSheet.footer.start); i++) {
            arrValues.splice(0, 0, "");
          }
          var row = worksheet2.addRow(arrValues);
          row.eachCell(function (cell, colNumber) {
            row.getCell(colNumber).font = { bold: true };
            row.getCell(colNumber).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'b2d1e2' }, bgColor: { argb: 'b2d1e2' } };
          });
        }
        worksheet2.eachRow(function (row, rowNumber) {
          row.eachCell(function (cell, colNumber) {
            row.getCell(colNumber).border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" }
            };
          });
        });
        for (let i = 0; i < worksheet2.columns.length; i++) {

          let dataMax = 3;
          const column = worksheet2.columns[i];
          var arr = Object.assign([], column.values);
          for (let j = 1; j < arr.length; j++) {
            if (arr[j]) {
              const columnLength = arr[j].toString().length;
              if (columnLength > dataMax) {
                dataMax = columnLength;
              }
            }
          }
          //column.width = 20;
          column.width = (dataMax > 0 && dataMax < 25) ? dataMax : 25
        }

      }
    }
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      importedSaveAs(blob, `${fileName}.xlsx`);
      let isLoading = false;
      this.reportLoadingService.setData(false);
      // console.log(data)
      return isLoading;
    });
    return false;
  }
  //bao cao chi tiet xu ly
  public detailProccessReport(body) {
    let url = this.baseUrl + '/report/detailProccessReport?token=' + this.data.token;


    return this.http.post<any>(url, body);
  }
  //bao cao KTV-thanhdv
  public operatorReport(body) {
    let url = this.baseUrl + '/report/operatorReport?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

    //bao cao KTV-thanhdv
    public operatorReport2(body) {
      let url = this.baseUrl + '/report/operatorReport2?token=' + this.data.token;
      return this.http.post<any>(url, body);
    }

  // badv báo cáo xử lý công việc theo chủ đề: danh sách bài viết
  public listPostsReport(body) {
    let url = this.baseUrl + '/report/listPostsReport?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  // badv báo cáo xử lý công việc theo chủ đề: danh sách bình luận
  public listCommentsReport(body) {
    let url = this.baseUrl + '/report/listCommentsReport?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  public loadPostCommentReport(body) {
    let url = this.baseUrl + '/report/loadPostCommentReport?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  getAggGeneralChart(body: any) {
    let url = this.baseUrl + '/report/getAggGeneralChart?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  loadSentimentChartData(body) {
    let url = this.baseUrl + '/report/loadSentimentChartData?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }

  //bao cao theo dõi xử lý bài viết
  public followProcessReport(body) {
    let url = this.baseUrl + '/report/followProcessReport?token=' + this.data.token;
    return this.http.post<any>(url, body);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/report.service.ts